import { MenuItem } from '../models/menu.model';

export class Menu {
  public static pages: MenuItem[] = [
    {
      group: 'Base',
      separator: false,
      items: [
        {
          icon: '',
          label: 'SIDE_BAR.HOME',
          route: '/dashboard',
          matIcon: 'home',
          children: [],
        },
      ],
    },
    {
      group: 'Administration',
      separator: false,
      items: [
        {
          icon: 'assets/icons/admin-icon.svg',
          label: 'SIDE_BAR.ADMINISTRATION',
          route: '/admin',
          matIcon: '',
          children: [
            // { label: 'SIDE_BAR.ORGANIZATION', route: '/admin/organizations' },
            // { label: 'SIDE_BAR.ADMIN_CONFIG', route: '/admin/config' },
            // { label: 'SIDE_BAR.MANAGE_CATEGORY', route: '/admin/categories' },
            // { label: 'SIDE_BAR.MANAGE_LANGUAGE', route: '/admin/language' },
            // { label: 'SIDE_BAR.LOG', route: '/admin/log' },
            { label: 'SIDE_BAR.MANAGE_USER', route: '/admin/users' },
            { label: 'SIDE_BAR.MANAGE_DEPARTMENT', route: '/admin/departments' },
            { label: 'SIDE_BAR.MANAGE_ROLE', route: '/admin/roles' },
            // { label: 'SIDE_BAR.USER_ACCESS', route: '/admin/user-access' },
            // { label: 'SIDE_BAR.SUPPLIER_ALIAS', route: '/admin/product-alias' },
            // { label: 'SIDE_BAR.SUPPLIER_ALIAS', route: '/admin/supplier-alias' },
          ],
        },
      ],
    },
  ];
}
